import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const devFirebaseConfig = {
  apiKey: 'AIzaSyBz8HD8fwyvWRqGasviot6wW3Zr4iknJCY',
  authDomain: 'cobalt-deck-455010-v4.firebaseapp.com',
  projectId: 'cobalt-deck-455010-v4',
  storageBucket: 'cobalt-deck-455010-v4.firebasestorage.app',
  messagingSenderId: '661511522',
  appId: '1:661511522:web:311220f7a0c1061bdca03b',
};

const prodFirebaseConfig = {
  apiKey: 'AIzaSyD1DkgR6y9jRzKXaV2edBdYQ-rRl5mCdo4',
  authDomain: 'camp-desk-prod.firebaseapp.com',
  projectId: 'camp-desk-prod',
  storageBucket: 'camp-desk-prod.firebasestorage.app',
  messagingSenderId: '481456014304',
  appId: '1:481456014304:web:681dd7a02969ea5f502185',
};

const firebaseConfig =
  import.meta.env.MODE === 'production'
    ? prodFirebaseConfig
    : devFirebaseConfig;

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
